import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Banner from "elements/Banner";
import { Button, Badge, Modal } from "react-bootstrap";
import Flickity from "react-flickity-component";
import DOMPurify from "dompurify";
import api from "services/api";
import Faqs from "components/Faqs";

export default function Promotions(props) {
  const __ = (text) => text;
  const flkty = useRef(null);

  const nextLoad = () => {
    flkty.current.next();
  };

  const prevLoad = () => {
    flkty.current.previous();
  };

  const isAuthenticated = props.isAuthenticated;

  const [promotions, setPromotions] = useState([]);
  const [pageContent, setPageContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [showPromotionModal, setShowPromotionModal] = useState(false);

  const getPromotions = async () => {
    try {
      setLoading(true);
      const response = await api.get("/promotions");
      
      if (response.status === 200) {
        setPromotions(response.data.promotions || []);
        setPageContent(response.data.content_data || "");
      }
    } catch (error) {
      console.error("Error fetching promotions:", error);
      // Fallback to empty array if API fails
      setPromotions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPromotions();
  }, []);

  const [show, setShow] = useState(0);
  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  const stripHtmlTags = (html) => {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };

  const renderMultiColorTitle = (title) => {
    if (!title) return null;
    
    // Split title by words
    const words = title.split(/\s+/).filter(word => word.trim());
    
    // Maximum character limit for first line to prevent overflow
    const MAX_FIRST_LINE_LENGTH = 12;
    
    // If only one word, show it all on first line
    if (words.length === 1) {
      return (
        <h3 className="promotion_title promotion_title_multicolor">
          <span className="title_line title_number">
            {words[0]}
          </span>
        </h3>
      );
    }
    
    // Words that should be kept with the next word to complete meaning
    const connectingWords = ['more', 'up', 'get', 'over', 'under', 'from', 'with'];
    const followUpWords = ['than', 'to', 'the', 'a', 'an', 'of'];
    
    let firstLine = '';
    let remainingIndex = 1;
    
    // Always include first word
    firstLine = words[0];
    const firstWordLower = words[0].toLowerCase();
    
    // Try to add more words while respecting MAX_FIRST_LINE_LENGTH
    // Keep adding words as long as they fit to maximize first line usage
    for (let i = 1; i < words.length; i++) {
      const testLine = firstLine + ' ' + words[i];
      if (testLine.length <= MAX_FIRST_LINE_LENGTH) {
        firstLine = testLine;
        remainingIndex = i + 1;
      } else {
        // Stop when we can't fit the next word
        break;
      }
    }
    
    const secondLine = words.slice(remainingIndex).join(' ');
    
    return (
      <h3 className="promotion_title promotion_title_multicolor">
        <span className="title_line title_number">
          {firstLine}
        </span>
        {secondLine && (
          <span className="title_line title_text">
            {secondLine}
          </span>
        )}
      </h3>
    );
  };

  return (
    <>
      
        <div className="main_content_area">
          <div className="container-xxl">
            <div className="promotions_area">
              

              <div className="promotions_item_area">
                {loading ? (
                  <div className="promotions_loading">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="loading_text">Loading promotions...</p>
                  </div>
                ) : (
                  <div className="promotions_grid">
                    {promotions.length > 0 ? (
                      promotions.map((promotion) => (
                        <div
                          key={promotion.id}
                          className="promotion_card"
                          role="button"
                          tabIndex={0}
                          onClick={() => {
                            setSelectedPromotion(promotion);
                            setShowPromotionModal(true);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              setSelectedPromotion(promotion);
                              setShowPromotionModal(true);
                            }
                          }}
                        >
                          <div className="promotion_image_container">
                            <img 
                              src={promotion.image} 
                              alt={promotion.title}
                              className="promotion_image"
                              loading="lazy"
                            />
                            <div className="promotion_image_overlay">
                              {renderMultiColorTitle(promotion.title)}
                            </div>
                          </div>
                          <div className="promotion_content">
                            <h3 className="promotion_title">{promotion.title}</h3>
                            <p className="promotion_description">{stripHtmlTags(promotion.details)}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="promotions_empty">
                        <div className="empty_icon">🎁</div>
                        <p className="empty_text">No promotions available at the moment.</p>
                        <p className="empty_subtext">Check back soon for exciting offers!</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <br />
              {/* {!props.isMobileDevice && (
                <center>
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="commonBtn pOneBtn"
                  >
                    {__("Get Your Promotion Now")}
                  </Link>
                </center>
              )} */}
            </div>
            <Faqs heading={true} {...props} />
          </div>
        </div>
      
      <Modal
        show={show}
        dialogClassName="modal-90w"
        onHide={() => setShow(false)}
      >
        <Modal.Body>
          <div
            onClick={() => {
              setShow(false);
            }}
            className="modal_close_reg small"
          >
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.26872 8.99995L1.05492 3.59305C0.775612 3.3034 0.589405 2.86892 0.589405 2.43443C0.589405 1.99995 0.775612 1.56547 1.05492 1.27581C1.66009 0.648226 2.68423 0.648226 3.2894 1.27581L8.5032 6.68271L13.717 1.27581C14.3222 0.648226 15.3463 0.648226 15.9515 1.27581C16.2308 1.56547 16.417 1.99995 16.417 2.43443C16.417 2.86892 16.2308 3.3034 15.9515 3.59305L10.7377 8.99995L15.9515 14.4068C16.2308 14.6965 16.417 15.131 16.417 15.5655C16.417 15.9999 16.2308 16.4344 15.9515 16.7241C15.6722 17.0137 15.2532 17.2068 14.8342 17.2068C14.4153 17.2068 13.9963 17.0137 13.717 16.7241L8.5032 11.3172L3.2894 16.7241C2.68423 17.3517 1.66009 17.3517 1.05492 16.7241C0.775612 16.4344 0.589405 15.9999 0.589405 15.5655C0.589405 15.131 0.775612 14.6965 1.05492 14.4068L6.26872 8.99995Z"
                fill="#10294F"
              />
            </svg>
          </div>
          <div className="bonusTerms">
            <h1 className="page_title">
              {pageContent && pageContent.page_title}
            </h1>

            <p className="paragraph desc">
              {pageContent && renderHTML(pageContent.content)}
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {/* Promotion details modal */}
      <Modal
        show={showPromotionModal}
        onHide={() => setShowPromotionModal(false)}
        centered
        size="lg"
        className="promotion_modal"
      >
        <Modal.Body className="promotion_modal_body">
          <button 
            className="promotion_modal_close"
            onClick={() => setShowPromotionModal(false)}
            aria-label="Close modal"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {selectedPromotion && (
            <div className="promotion_details_area">
              <div className="promotion_hero_area">
                <div className="promotion_hero_image">
                  <img src={selectedPromotion.image} alt={selectedPromotion.title} />
                </div>
                <div className="promotion_hero_content">
                  <h1 className="promotion_title">{selectedPromotion.title}</h1>
                </div>
              </div>
              <div className="promotion_details_content_area">
                {renderHTML(selectedPromotion.details)}
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
